import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorsLog } from '../models/classes/Dashboard/errorLog';
import { TestResult } from '../models/classes/Dashboard/test-result';
import { IsTestLaunched } from '../models/classes/IsTestLaunched/is-test-launched';
import { LicenceCount } from '../models/classes/Dashboard/licence/licence-count';
import { Cities, CityData } from '../models/classes/Dashboard/cityData/city-data';
import { DataByYears } from '../models/classes/Dashboard/cityData/data-type-by-year';
import { CityGeneralInformation } from '../models/classes/Dashboard/cityData/city-general-information';
import { CitiesDataStatus, CityDataStatus } from '../models/classes/Dashboard/cityData/city-data-status';
import { ProvidersStatus } from '../models/classes/Dashboard/Provider/provider-status';
import { TestsStat } from '../models/classes/Dashboard/Test/test-stat';
import { ReleaseNotes } from '../models/classes/Dashboard/bizzmine/release-note';
import { ConnexionCount } from '@classes/Dashboard/connexion-count';


@Injectable({
    providedIn: 'root'
})
export class DashboardBizzDevService {
    private baseUrl = environment.apiUrl + 'dashboard-test';
    private bizzmineUrl = environment.bizzmineDashboardUrl;
    private bizzmineApiKey = environment.bizzmineApiKeyDashboard;

    constructor(private http: HttpClient) { }

    setErrorCheckedState(id: number): Observable<any> {
        const parameter =
            "?id=" + id;
        return this.http.post<any>(`${this.baseUrl}/set-error-state` + parameter, null);
    }

    getTest(): Observable<TestResult> {
        return this.http.get<TestResult>(`${this.baseUrl}/test-results`);
    }

    getErrorLog(minDate: Date, maxDate: Date): Observable<ErrorsLog> {
        const params = new HttpParams()
            .set('minDate', minDate.toDateString())
            .set('maxDate', maxDate.toDateString());
        return this.http.get<ErrorsLog>(`${this.baseUrl}/error-log`, { params })
    }


    launchTest(providerCode: string): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/launch-test`, providerCode);
    }
    getIsTestLaunchedState(): Observable<IsTestLaunched> {
        return this.http.get<IsTestLaunched>(`${this.baseUrl}/is-running`);
    }

    getLastProdDeploymentDate(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/prod-deployment-date`);
    }
    getProviderImportDate(providerCode: string): Observable<any> {
        const parameter =
            "?providerCode=" + providerCode;
        return this.http.get<any>(`${this.baseUrl}/import-date` + parameter);
    }
    getCityData(providerCode: string): Observable<Cities> {
        const parameter =
            "?providerCode=" + providerCode;
        return this.http.get<Cities>(`${this.baseUrl}/city-data` + parameter);
    }
    getDataTypeByYear(id: number): Observable<DataByYears> {
        const parameter =
            "?id=" + id;
        return this.http.get<DataByYears>(`${this.baseUrl}/data-type-by-year` + parameter);

    }
    getCityGeneralInformationByID(id: number): Observable<CityGeneralInformation> {
        const parameter =
            "?id=" + id;
        return this.http.get<CityGeneralInformation>(`${this.baseUrl}/city-general-information` + parameter)
    }

    getErrorNumber(): Observable<number> {
        return this.http.get<number>(`${this.baseUrl}/error-number`)
    }

    GetNumberLicence(): Observable<LicenceCount> {
        return this.http.get<LicenceCount>(`${this.baseUrl}/licence-count`)
    }

    getBankerData(id: number): Observable<string> {
        const parameter =
            "?id=" + id;
        return this.http.get<string>(`${this.baseUrl}/banker-data` + parameter)
    }

    getUsersConnexionNumber(): Observable<ConnexionCount> {
        return this.http.get<ConnexionCount>(`${this.baseUrl}/users-connexion-number`);
    }

    getBadCities(): Observable<CitiesDataStatus> {
        return this.http.get<CitiesDataStatus>(`${this.baseUrl}/bad-cities`)
    }

    getExpiredLicences(): Observable<number> {
        return this.http.get<number>(`${this.baseUrl}/expired-licences`)
    }

    getProviderStatus(): Observable<ProvidersStatus> {
        return this.http.get<ProvidersStatus>(`${this.baseUrl}/provider-status`)
    }
    getTestStats(): Observable<TestsStat> {
        return this.http.get<TestsStat>(`${this.baseUrl}/test-stat`);
    }

    getOpenTicketNumber(): Observable<number> {
        const headers = new HttpHeaders()
            .set('apiKey', this.bizzmineApiKey );
        return this.http.get<number>(`${this.bizzmineUrl}/Issue/SymiaSupport/opened`, { headers });
    }

    getReleaseNotes(): Observable<ReleaseNotes> {
        const headers = new HttpHeaders()
            .set('apiKey', this.bizzmineApiKey);
        const params = "?projectName=" + "SymiaProd";
        return this.http.get<ReleaseNotes>(`${this.bizzmineUrl}/Issue/short` + params, { headers });

    }
}

